/**
 * Array of supported locale codes.
 * Add or remove locale codes as your application requirements change.
 */
const supportedLocales = ['en', 'es']; // Extend this array with additional locales as needed

export default supportedLocales;